export default "__VITE_ASSET__BQWXXAPc__"